import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function PaymentPaypalRedirectModal({ showModal, close, invoice_data, embedded = false }) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [paypalClientId, setPaypalClientId] = useState(null);

  useEffect(() => {
    // Obtener el PAYPAL_CLIENT_ID del backend
    const fetchPaypalConfig = async () => {
      try {
        const response = await fetch('/api/paypal-config');
        if (response.ok) {
          const data = await response.json();
          setPaypalClientId(data.paypalClientId);
        } else {
          setError('Error al obtener la configuración de PayPal');
        }
      } catch (err) {
        setError('Error al conectarse con el backend');
      }
    };

    fetchPaypalConfig();
  }, []);

  useEffect(() => {
    // Cargar el script de PayPal solo si tenemos el client-id
    if (paypalClientId) {
      const script = document.createElement('script');
      script.src = `https://www.paypal.com/sdk/js?client-id=${paypalClientId}&components=buttons`;
      script.async = true;
      document.body.appendChild(script);
    }
  }, [paypalClientId]);

  const handlePaypalPayment = async () => {
    setLoading(true); // Empieza el indicador de carga
    setError(null); // Reseteamos el error antes de intentar el pago

    try {
      // Llamar al backend para crear el pedido de PayPal
      const response = await fetch('/api/payment_paypal_redirect', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          invoice_id: invoice_data.id,
          amount_residual: invoice_data.amount_residual,
          currency: invoice_data.currency,
          invoice_name: invoice_data.name,
        }),
      });

      // Verificar que la respuesta sea válida
      if (response.ok) {
        const sessionData = await response.json();

        // Redirigir al usuario a la URL de PayPal para completar el pago
        if (sessionData.approval_url) {
          window.location.href = sessionData.approval_url; // Redirigir a PayPal
        } else {
          throw new Error('No se recibió la URL de aprobación');
        }
      } else {
        throw new Error('Error al crear el pedido de PayPal');
      }
    } catch (error) {
      console.error('Error al procesar el pago:', error);
      setError(error.message || 'Hubo un problema al procesar el pago');
    } finally {
      setLoading(false); // Finaliza el estado de carga
    }
  };

  const content = (
    <>
      <div className="text-dark pb-2 text-center">
        <strong>{t('invoice')} {invoice_data.name}</strong>
      </div>
      <div className="text-dark pb-2 fw-bold text-center">
        <strong>{t('total-to-pay')} {invoice_data.amount_residual} {invoice_data.currency}</strong>
      </div>

      {/* Mostrar mensaje de error si existe */}
      {error && <div className="alert alert-danger">{error}</div>}

      <div className="d-flex justify-content-center">
        <Button variant="success" type="button" onClick={handlePaypalPayment} disabled={loading}>
          {loading ? <i className="ri-loader-line ri-spin"></i> : <i className="ri-check-line me-1"></i>}
          {t('pay-paypal')}
        </Button>
      </div>
    </>
  );

  if (embedded) {
    return content;
  }

  return showModal ? (
    <Modal show={showModal} onHide={close}>
      <Modal.Header closeButton>
        <Modal.Title className="modal-title text-dark text-center">
          {t('confirm-and-pay')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">{content}</Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={close}>
          <i className="ri-close-line me-1"></i> {t('btn-close')}
        </Button>
      </Modal.Footer>
    </Modal>
  ) : null;
}

export default PaymentPaypalRedirectModal;
